import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import usePermissions from '@/hooks/use-permissions';
import useSession from '@/hooks/use-session';
import MenuDropdown, { type MenuLink } from '../menu-dropdown';
export type ReportingDropdownProps = {
  text: string;
  icon: Icon;
  isCollapsed: boolean;
  pathname: string;
};
const ReportingDropdown = t0 => {
  const $ = _c(22);
  const {
    text,
    icon: Icon,
    isCollapsed,
    pathname
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const {
    data: t2
  } = useSession();
  const {
    user
  } = t2;
  const {
    isAuditor
  } = usePermissions();
  const isFirmEmployee = !!user?.isFirmEmployee;
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = {
      href: "/reporting/onboarding-metrics",
      text: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isFirmEmployee || $[6] !== t) {
    t5 = isFirmEmployee ? [{
      href: "/reporting/live-agent-activity",
      text: t(_temp2)
    }] : [];
    $[5] = isFirmEmployee;
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp3);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      href: "/reporting/analysis",
      text: t6
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
    t8 = [t4, ...t5, t7];
    $[12] = t4;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const subLinks = t8;
  if (isAuditor) {
    return null;
  }
  let t9;
  if ($[16] !== Icon || $[17] !== isCollapsed || $[18] !== pathname || $[19] !== subLinks || $[20] !== text) {
    t9 = <MenuDropdown text={text} icon={Icon} isCollapsed={isCollapsed} subLinks={subLinks} pathname={pathname} />;
    $[16] = Icon;
    $[17] = isCollapsed;
    $[18] = pathname;
    $[19] = subLinks;
    $[20] = text;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default ReportingDropdown;
function _temp($) {
  return $.reportingSubmenus.onboardingMetrics;
}
function _temp2($_0) {
  return $_0.reportingSubmenus.liveAgents;
}
function _temp3($_1) {
  return $_1.reportingSubmenus.analysis;
}